import React, { useState, useEffect } from 'react';
import axios from 'axios';
import styled from 'styled-components';
import { toast } from 'react-hot-toast';
import AdminLayout from '../../components/AdminLayout';

const StyledModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;
const ModalContent = styled.div`
  background: white;
  border-radius: 12px;
  padding: 2rem;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);

  h2 {
    margin: 0 0 1.5rem;
    font-size: 1.8rem;
    color: #333;
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
  }
`;

const AmazonUsersPage = () => {
  const [amazonUsers, setAmazonUsers] = useState([]);
  const [showCreateAmazonUser, setShowCreateAmazonUser] = useState(false);
  const [newAmazonUser, setNewAmazonUser] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const adminRank = localStorage.getItem('adminRank');

  useEffect(() => {
    if (adminRank !== 'owner') return;
    fetchAmazonUsers();
    // eslint-disable-next-line
  }, []);

  const fetchAmazonUsers = async () => {
    try {
      const token = localStorage.getItem('adminToken');
      const res = await axios.get('/api/admin/amazon-users', { headers: { Authorization: `Bearer ${token}` } });
      setAmazonUsers(res.data.users);
      setLoading(false);
    } catch (err) {
      setError('Failed to fetch Amazon users');
      setLoading(false);
    }
  };

  const handleCreateAmazonUser = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('adminToken');
      const res = await axios.post('/api/admin/amazon-users', newAmazonUser, { headers: { Authorization: `Bearer ${token}` } });
      if (res.data.success) {
        setShowCreateAmazonUser(false);
        setNewAmazonUser({ username: '', password: '' });
        toast.success('Amazon user account created successfully');
        fetchAmazonUsers();
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to create Amazon user account');
    }
  };

  const handleDeleteAmazonUser = async (id) => {
    if (!window.confirm('Are you sure you want to delete this Amazon user?')) return;
    try {
      const token = localStorage.getItem('adminToken');
      const res = await axios.delete(`/api/admin/amazon-users/${id}`, { headers: { Authorization: `Bearer ${token}` } });
      if (res.data.success) fetchAmazonUsers();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to delete Amazon user');
    }
  };

  if (adminRank !== 'owner') {
    return <AdminLayout><div className="unauthorized-message">Only owners can view Amazon users.</div></AdminLayout>;
  }

  if (loading) {
    return <AdminLayout><div className="loading">Loading...</div></AdminLayout>;
  }

  return (
    <AdminLayout>
      <section>
        <div className="section-header">
          <h2>Amazon Users</h2>
          <button onClick={() => setShowCreateAmazonUser(true)} className="action-button">Create Amazon User</button>
        </div>
        {error && <div className="error-message">{error}</div>}
        <table className="data-table">
          <thead>
            <tr>
              <th>Username</th>
              <th>Created At</th>
              <th>Last Login</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {amazonUsers.map(user => (
              <tr key={user.id}>
                <td>{user.username}</td>
                <td>{new Date(user.created_at).toLocaleString()}</td>
                <td>{user.last_login ? new Date(user.last_login).toLocaleString() : 'Never'}</td>
                <td>
                  <button className="action-button delete-button" onClick={() => handleDeleteAmazonUser(user.id)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Create Amazon User Modal */}
        {showCreateAmazonUser && (
          <StyledModal>
            <ModalContent>
              <h2>Create Amazon User Account</h2>
              <form onSubmit={handleCreateAmazonUser}>
                <div className="form-group">
                  <label>Username</label>
                  <input type="text" value={newAmazonUser.username} onChange={e => setNewAmazonUser({ ...newAmazonUser, username: e.target.value })} required placeholder="Enter username" />
                </div>
                <div className="form-group">
                  <label>Password</label>
                  <input type="password" value={newAmazonUser.password} onChange={e => setNewAmazonUser({ ...newAmazonUser, password: e.target.value })} required placeholder="Enter password" />
                </div>
                <div className="modal-actions">
                  <button type="button" onClick={() => setShowCreateAmazonUser(false)}>Cancel</button>
                  <button type="submit">Create Account</button>
                </div>
              </form>
            </ModalContent>
          </StyledModal>
        )}
      </section>
    </AdminLayout>
  );
};

export default AmazonUsersPage; 